import BREAK_POINTS from '@soluto-home-web/platform-common-ui/styling/media-queries';
import React from 'react';
import styled from 'styled-components';
import { DynamicLink } from '../../components';
import { CallToAction } from '../../styling/styles';
import { Action } from '../fees-and-deductibles/models';
import NeedHelpButton from '../profile/components/NeedHelpButton';

const s = {
  NeedHelpButton: styled(NeedHelpButton)`
    font-size: 15px;
    padding: 14px 28px;
    margin: 0px auto 100px auto;
  `,
  ActionBlock: styled(DynamicLink)<{ inverted?: boolean }>`
    ${CallToAction}
    width: 320px;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    line-height: 1px;
    font-weight: 400;
    font-style: normal;
    padding: 16px 30px;
    margin: 70px auto 15px auto;

    @media ${BREAK_POINTS.desktop} {
      font-weight: normal;
    }
  `,
};

export type PageActionProps = Action & {
  id: string;
  analyticsExtras?: Record<string, string>;
};

const PageAction = ({ type, description, url, invert, id, analyticsExtras }: PageActionProps) => {
  switch (type) {
    case 'expert':
      return <s.NeedHelpButton id={id} analyticsExtras={analyticsExtras} text={description} />;
    case 'url':
      return (
        <s.ActionBlock id={id} analyticsExtras={analyticsExtras} inverted={invert} to={url}>
          {description}
        </s.ActionBlock>
      );
    default:
      return null;
  }
};

export default PageAction;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/whats-covered/PageAction.tsx